import script from "./ContentLabel.vue?vue&type=script&setup=true&lang=ts"
export * from "./ContentLabel.vue?vue&type=script&setup=true&lang=ts"

import "./ContentLabel.vue?vue&type=style&index=0&id=563cc37e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-563cc37e"]])

export default __exports__